<script>
    import { redirect } from '@sveltech/routify'

    $redirect('../send')
</script>
